<template>
  <div class="comments-container">
    <div class="comments-item" v-for="(item, index) in commentList" :key="index">
      <div class="item-header">
        <span class="hm-name">{{ item.created_account }}</span>
        <div class="rating-time-container">
          <span class="rating-date">{{ formatCreateTime(item.created_date) }}</span>
          <span class="rating-time">{{ item.created_time }}</span>
        </div>
      </div>
      <div class="item-body">
        <el-input
          type="textarea"
          :autosize="textSize"
          readonly
          resize="none"
          v-model="item.comment"
          class="title">
        </el-input>
      </div>
    </div>
    <p class="rating-tips">{{ $t('hm.label.rating.commentTips') }}</p>
  </div>
</template>

<script>
import moment from 'moment'
import { isEn } from '@/i18n'

export default {
  components: {
  },
  props: {
    commentList: {
      require: true
    }
  },
  data () {
    return {
      textSize: {
        minRows: 3,
        maxRows: 5
      }
    }
  },
  computed: {
  },
  created () {
  },
  beforeDestroy () {

  },
  methods: {
    formatCreateTime (time) {
      if (time) {
        const date = moment(time)
        date.locale(isEn() ? 'en' : 'zh-cn')
        return date.format('MMMM DD, YYYY')
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.comments-container {
  background-color: #FFFFFF;
  padding: 40px;

  .comments-item {
    margin-bottom: 40px;
  }

  .item-header {
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    font-size: 18px;

    .rating-date {
      font-size: 12px;
      color: #000000;
      margin-right: 30px;
    }

    .rating-time {
      color: #0096cc;
      font-size: 12px;
    }

  }

  .rating-tips {
    text-align: right;
    color: #808080;
  }
}
</style>
